import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGlobalDialog } from "../../Store/DialogManager";

import { useSnackbar } from "notistack";
import styled from 'styled-components';
import {
    Card,
    Typography,
} from "@mui/material";

import { IconCircleCheckFilled, IconChevronRight } from '@tabler/icons-react';

import { GeneratedLicenseInvoiceModalInterface } from '../../Models/License/License';

import { ButtonType } from '../../Utilities/Enums/ButtonTypeEnum';
import { RouteEnum } from '../../Utilities/Enums/RouteEnums';
import { ViewType } from '../../Utilities/Enums/ViewTypeEnum';

import CustomButton from '../../CustomViews/Elements/CustomButton';
import GeneratedLicenseKey from '../../CustomViews/Pages/GeneratedLicenseKey/GeneratedLicenseKey';

const ModalContentContainer = styled.div <{ $darkMode?: boolean; }>`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    width: 40vw;
`;

const GeneratedLicenseKeyContainer: any = styled(Card)<{ }>`
    background: transparent !important;
    border: none;
    border-radius: 0px !important;
    box-shadow: none !important;
    width: 500px;
    display: grid;
    grid-template-columns: 1fr;
    place-items: center;
    align-items: center;
    padding: 10px;
    justify-self: center;

    .headersvg {
        width: 80px;
        height: 80px;
        margin: 0px 0px 40px 0px;
    }
    
    .headerTitle {
        font-size: 1.09375rem !important;
        font-weight: 600;
    }

    .headerSubtitle {
        font-size: 0.825rem !important;
        font-weight: 500;
        color: #878a99;
    }

    .actionBtn {
        margin: 40px 0px;
    }
`;

const ItemContainer: any = styled(Card)<{ }>`
    background: transparent !important;
    border: none;
    border-radius: 0px !important;
    box-shadow: none !important;
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 20px 0px 0px 0px;

    .itemTitle, .itemValue {
        font-size: 1.09375rem;
        font-weight: 600 !important
    }

    .itemValue {
        margin: 0px 0px 0px 5px;
        color: #f06548 !important;
    }

    .invoiceNo {
        color: #25a0e2 !important;
        text-decoration: underline;
        cursor: pointer;
    }

    .licenseKey {
        cursor: pointer;
    }
`;

export default function GeneratedLicenseInvoiceModal(props: GeneratedLicenseInvoiceModalInterface) {
    const navigate = useNavigate();
    const { setDialogContent, setOpenGlobalDialog } = useGlobalDialog();
    let { openGeneratedInvoiceModal, setopenGeneratedInvoiceModal, generatedInvoicePublicId, setgeneratedInvoicePublicId, generatedInvoiceNo, setgeneratedInvoiceNo } = props;

    //Use States

    //Event Handlers
    const onCloseDialog = async (e: any = null) => {
        if(e) {
            e.preventDefault();
        }

        if(setopenGeneratedInvoiceModal) {
            setopenGeneratedInvoiceModal(false);
        }

        if(setgeneratedInvoicePublicId) {
            setgeneratedInvoicePublicId(null);
        }

        if(setgeneratedInvoiceNo) {
            setgeneratedInvoiceNo(null);
        }

        setOpenGlobalDialog(false);
    }

    useEffect(() => {
        if(openGeneratedInvoiceModal) {
            setDialogContent({
                title: "Generate Invoice",
                clearDialog: onCloseDialog,
                onCloseDialog: onCloseDialog,
                children: renderDialogContent(),
            });
        }
    }, [openGeneratedInvoiceModal]);

    //Rendering Functions
    const renderDialogContent = () => {
        return <GeneratedLicenseKeyContainer>
            <IconCircleCheckFilled className="headersvg" color='var(--hrDashboardIconColor)'/>
            <Typography className="headerTitle" color='primaryText'>Invoice Generated</Typography>
            <Typography className="headerSubtitle">You have successfully generated a new invoice.</Typography>

            {generatedInvoiceNo && <ItemContainer>
                <Typography className="itemTitle" color='primaryText'>Invoice No.:</Typography>
                <Typography className="itemValue" onClick={() => {
                    // if(props?.onclickInvoiceNo) {
                    //     props.onclickInvoiceNo();
                    // }
                }} >
                    {generatedInvoiceNo ?? "--"}
                </Typography>
            </ItemContainer>}

            <CustomButton
                    className="actionBtn"
                    btnType={ButtonType.PRIMARY_LIGHT}
                    title='View Invoice'
                    endIcon={<IconChevronRight />}
                    onClick={(e: any) => {
                        navigate(`${RouteEnum.BILLING_DETAILS}?id=${generatedInvoicePublicId}&view=${ViewType.PREVIEW}`, { replace: true });
                        onCloseDialog();
                    }} />
        </GeneratedLicenseKeyContainer>
    }

    return <></>
}
